(function (root) {
  'use strict';

  function days(value) {
    const text = String(value ?? '').trim();
    if (!/^[1-9]\d*$/.test(text)) return null;
    const number = Number(text);
    return number <= 90 ? number : null;
  }

  function complete(values) {
    if (!values || values.enabled !== true) return null;
    const productionMin = days(values.productionMin);
    const productionMax = days(values.productionMax);
    const shippingMin = days(values.shippingMin);
    const shippingMax = days(values.shippingMax);
    if (!productionMin || !productionMax || productionMin > productionMax || !shippingMin || !shippingMax || shippingMin > shippingMax) return null;
    return {mode: 'arrival', productionMin, productionMax, shippingMin, shippingMax};
  }

  function legacy(values) {
    if (!values || values.enabled !== true) return null;
    const productionMin = days(values.productionMin);
    const productionMax = days(values.productionMax);
    if (!productionMin || !productionMax || productionMin > productionMax) return null;
    const shippingMin = days(values.shippingMin);
    const shippingMax = days(values.shippingMax);
    if (!shippingMin || !shippingMax || shippingMin > shippingMax) {
      return {mode: 'production', productionMin, productionMax};
    }
    return {mode: 'arrival', productionMin, productionMax, shippingMin, shippingMax};
  }

  function timing(values) {
    if (!values) return null;
    if (!values.override && !values.defaults) return legacy(values);
    const override = complete(values.override);
    const defaults = complete(values.defaults);
    if (override || defaults) return override || defaults;
    return values.defaults?.enabled === true ? null : legacy(values.override);
  }

  function addBusinessDays(start, count) {
    const date = new Date(start.getTime());
    for (let elapsed = 0; elapsed < count;) {
      date.setUTCDate(date.getUTCDate() + 1);
      if (date.getUTCDay() !== 0 && date.getUTCDay() !== 6) elapsed++;
    }
    return date;
  }

  function calculate(now, values) {
    if (!values || values.mode !== 'arrival' || !(now instanceof Date) || Number.isNaN(now.getTime())) return null;
    const selected = timing({...values, enabled: true});
    if (!selected || selected.mode !== 'arrival') return null;
    const start = new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()));
    const minDays = selected.productionMin + selected.shippingMin;
    const maxDays = selected.productionMax + selected.shippingMax;
    return {
      earliest: addBusinessDays(start, minDays).toISOString().slice(0, 10),
      latest: addBusinessDays(start, maxDays).toISOString().slice(0, 10),
      minDays,
      maxDays
    };
  }

  root.czDraperyMasterArrival = {addBusinessDays, calculate, timing};
})(window);
